/*
    CompanyUsername should only contain small letters.
*/
export function companyUserNameRule(message = "Darf nur Kleinbuchstaben enthalten"): (value: any) => boolean | string {
  const companyUserNameRegEx = RegExp(/^[a-z]+$/);
  return value => companyUserNameRegEx.test(value) || message;
}
